/**
 * Created by jv on 10/01/2017.
 */
const moment = require("moment");
const utils = require("Sources/utils/utils");

var dataFilter = {};

(function(DataFilter)
{
  DataFilter.search = function(data, searchString, type)
  {
    return DataFilter.filter(data, null, [ searchString ], false, type);
  };

  DataFilter.filter = function(data, property, values, exact, type)
  {
    return filterArray(data, property, values, exact, type);
  };

  DataFilter.sort = function(data, sortType, sortKey, asc)
  {
    // temporary array holds objects with position and sort-value
    var mapped = data.map(function(el, i)
    {
      var value = el[sortKey];

      if(utils.isMomentObject(value))
      {
        value = value.toDate();
      }

      return { index: i, value: value };
    });

    // sorting the mapped array containing the reduced values
    switch(sortType)
    {
      case "date":
        mapped.sort(function(a, b)
        {
          // return asc ? a.value - b.value : b.value - a.value;
          var left = asc ? a.value : b.value;
          var right = asc ? b.value : a.value;

          return moment.utc(left).diff(moment.utc(right));
        });
        break;
      case "number":
        mapped.sort(function(a, b)
        {
          return asc ? (+a.value - +b.value) :  (+b.value - +a.value);
        });
        break;
      case "string":
        mapped.sort(function(a, b)
        {
          // Fail safe
          var valA = utils.isNotNull(a.value) ? a.value : "",
              valB = utils.isNotNull(b.value) ? b.value : "";

          return !asc ? valA.localeCompare(valB) : valB.localeCompare(valA);
        });
        break;
      default:
        mapped.sort(function(a, b)
        {
          return asc ? a.value - b.value : b.value - a.value;
        });
    }

    // container for the resulting order
    return mapped.map(function(el){
      return data[el.index];
    });
  };

  function filterArray(array, property, searchValues, exact, type)
  {
  	return array.filter(function(obj)
    {
  		var result = findInObject(obj, property, searchValues, exact, type);

      return result.length > 0;
    });
  }

  function findInObject(obj, property, searchValues, exact, type)
  {
    var result = [];

    if(utils.isArray(obj))
    {
      for(var i = 0; i < obj.length; i++)
      {
        var tmpResult1 = findInObject(obj[i], property, searchValues, exact, type);
        result = result.concat(tmpResult1);
      }
    }
    else if(utils.isObject(obj))
    {
      for(var prop in obj)
      {
        if(obj.hasOwnProperty(prop) && (utils.isNull(property) || property === prop))
        {
          if(utils.isObject(obj[prop]) || utils.isArray(obj[prop]))
          {
            var tmpResult2 = findInObject(obj[prop], property, searchValues, exact, type);
            result = result.concat(tmpResult2);
          }
          else
          {
            if(compareValues(obj[prop], searchValues, exact, type))
            {
              result.push(obj);
            }
          }
        }
      }
    }
    else // If obj is not an object or array
    {
      if(compareValues(obj, searchValues, exact, type))
      {
        result.push(obj);
      }
    }


    return result;
  }

  function compareValues(value, searchValues, exact, type)
  {
    if(utils.isUndefined(type) || typeof value === type)
    {
      for(var x = 0; x < searchValues.length; x++)
      {
        var searchValue = searchValues[x];
        var objValue = value + "";

        if(exact === true)
        {
          if(objValue === searchValue)
          {
            return true;
          }
        }
        else
        {
          if(objValue.toUpperCase().includes(searchValue.toUpperCase()))
          {
            return true;
          }
        }
      }
    }

    return false;
  }

}(dataFilter));

module.exports = dataFilter;



// WEBPACK FOOTER //
// ./app/js/components/data-filter.js